import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Footer from "../components/Footer";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is an online clipboard and how does it work?",
      answer: (
        <>
          An online clipboard is a web-based tool that allows you to store and transfer text between devices using the internet. You paste your text, generate a unique code, and use that code on another device to retrieve it instantly.
        </>
      ),
    },
    {
      question: "Why should I use an online clipboard instead of email or WhatsApp?",
      answer: (
        <>
          Email and messaging apps require multiple steps and take more time. An online clipboard is faster because it is built specifically for text transfer and works instantly without login.
        </>
      ),
    },
    {
      question: "Is an online clipboard safe to use?",
      answer: (
        <>
          Yes, it uses a unique code system. Only users with the correct code can access the text. Avoid sharing sensitive information for better safety.
        </>
      ),
    },
    {
      question: "Do I need to create an account to use ClickBoard?",
      answer: (
        <>
          No, ClickBoard works without any registration. You can use it instantly without creating an account.
        </>
      ),
    },
    {
      question: "Can I use ClickBoard on mobile and desktop?",
      answer: (
        <>
          Yes, ClickBoard works on all devices including mobile, tablet, and desktop browsers.
        </>
      ),
    },
    {
      question: "What type of content can I share?",
      answer: (
        <>
          You can share links, notes, code snippets, addresses, and general text easily.
        </>
      ),
    },
    {
      question: "Is ClickBoard free to use?",
      answer: (
        <>
          Yes, ClickBoard is completely free with no hidden charges or subscriptions.
        </>
      ),
    },
    {
      question: "Do I need to install anything?",
      answer: (
        <>
          No, it works directly in your browser. No installation required.
        </>
      ),
    },
    {
      question: "How fast is text transfer?",
      answer: (
        <>
          Text transfer is instant. It takes only a few seconds to move text between devices.
        </>
      ),
    },
    {
      question: "When should I use an online clipboard?",
      answer: (
        <>
          Use it whenever you need to quickly transfer text between devices without using email or apps.
        </>
      ),
    },
  ];

  return (
    <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6 transition-colors duration-300">
      <div className="max-w-6xl mx-auto">

        {/* TITLE */}
        <h2 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
          Frequently Asked Questions
        </h2>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-card dark:bg-cardDark rounded-2xl p-6 border border-borderLight dark:border-borderDark transition-all duration-300"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex justify-between items-center text-left"
              >
                <span className="text-lg md:text-xl font-semibold text-titleLight dark:text-titleDark">
                  {faq.question}
                </span>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`text-titleLight dark:text-titleDark text-xl transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                    }`}
                />
              </button>

              {openIndex === index && (
                <div className="mt-4 text-textMain dark:text-textDark leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </section>
  );
}